import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClockIcon, HeartHandshakeIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-purple-dark via-purple to-gold-dark/80 px-4 py-20" data-id="element-128">
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-black/20" data-id="element-129" />

      <div className="relative z-10 max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-130">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left space-y-8" data-id="element-131">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight text-balance" data-id="element-132">
            ¿Ves el saldo rojo a medianoche y sientes el peso de las facturas
            antes de dormir?
          </h1>

          <p className="text-lg md:text-xl text-cream/90 font-body max-w-2xl mx-auto lg:mx-0" data-id="element-133">
            No eres mala con el dinero. Eres una mamá luchando sola con salarios
            desiguales y gastos que no paran.
          </p>

          <div className="pt-4 flex flex-col items-center lg:items-start space-y-4" data-id="element-134">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} animate={{
            boxShadow: ['0px 0px 0px rgba(245, 158, 11, 0)', '0px 0px 20px rgba(245, 158, 11, 0.5)', '0px 0px 0px rgba(245, 158, 11, 0)']
          }} transition={{
            boxShadow: {
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          }} className="w-full sm:w-auto px-8 py-4 bg-gold hover:bg-gold-light text-charcoal font-bold text-xl rounded-full shadow-xl transition-colors flex items-center justify-center gap-2" onClick={() => document.getElementById('descarga')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-135">
              ¡DESCARGA AHORA — $17!
            </motion.button>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-sm text-cream/80 font-medium" data-id="element-136">
              <span className="flex items-center gap-1" data-id="element-137">
                <ClockIcon className="w-4 h-4" data-id="element-138" /> Instantáneo
              </span>
              <span className="hidden sm:inline" data-id="element-139">•</span>
              <span className="flex items-center gap-1" data-id="element-140">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-141" /> Acceso vitalicio
              </span>
              <span className="hidden sm:inline" data-id="element-142">•</span>
              <span className="flex items-center gap-1" data-id="element-143">
                <HeartHandshakeIcon className="w-4 h-4" data-id="element-144" /> Soporte incluido
              </span>
            </div>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-145">
          <div className="aspect-[4/5] sm:aspect-square lg:aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl border-4 border-gold/30 relative" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/eHqeRo4fo2yF4H29ovC7QZ/Plantillas_de_Presupuesto_en_Excel.png" alt="Mamá latina abrazando a sus hijos mientras revisa su presupuesto en Excel" className="w-full h-full object-cover object-center" data-id="element-147" />
            {/* Subtle gradient overlay on image bottom for blending if needed */}
            <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-purple-dark/80 to-transparent" data-id="element-148" />
          </div>
        </motion.div>
      </div>
    </section>;
}